// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"ee8def12","920":"31d6cfe0"}[chunkId] + ".chunk.css";
};